import * as React from 'react';
import { SectionPanel } from 'ui/section-panel/section-panel';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { CodetableItemFormComponentProps } from 'app/area/codetable/item/codetable-item-form';
import { SlotProps } from 'app/area/codetable/item/types';
import { renderSlot } from 'app/area/codetable/item/screen-renderer/render-slot';
import { CodetableTranslation } from 'app/area/codetable/constants';

export const ScalarValues = (props: Partial<CodetableItemFormComponentProps> & SlotProps
  & { scalarValuesInfo?: (translation: CodetableTranslation) => string }) => {

  const { translation, sectionSlots, sectionRef, scalarValuesInfo } = props;

  return <div ref={sectionRef}>
    <SectionPanel
      className="admin-paper-top-panel"
      componentId="scalar_values"
      validation={undefined}
      info={{ text: scalarValuesInfo(translation), visible: true }}
      label={{ visible: true, text: translation.scalar_values }} />
    <MainGridContainer>
      <div className="row">
        {renderSlot(sectionSlots, 'top', props)}
      </div>
    </MainGridContainer>
  </div>;
};
